// AuthContext.jsx
import React, { createContext, useState, useContext } from 'react';
import { jwtDecode } from 'jwt-decode';
import axios from "axios";

axios.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// token vencido (24h): limpa e volta para o login
axios.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem("token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export const AuthContext = createContext(undefined);
export const useAuth = () => useContext(AuthContext);

// Lê o token já na primeira renderização (evita "piscar" e ser mandado ao login ao recarregar a página)
function lerSessao() {
  try {
    const token = sessionStorage.getItem('token');
    if (!token) return null;
    const d = jwtDecode(token);
    if (d.exp && d.exp * 1000 < Date.now()) return null;   // vencido
    return d;
  } catch {
    return null;
  }
}

export const AuthProvider = ({ children }) => {
  const [sessao, setSessao] = useState(lerSessao);

  const login = (token) => {
    try {
      const d = jwtDecode(token);
      sessionStorage.setItem('token', token);
      setSessao(d);
    } catch (error) {
      console.error('Failed to decode token', error);
      logout();
    }
  };

  const logout = () => {
    sessionStorage.removeItem('token');
    setSessao(null);
  };

  return (
    <AuthContext.Provider value={{
      isAuthenticated: !!sessao,
      nome: sessao?.nome ?? null,
      user: sessao?.tipo ?? null,            // 'ADMIN' | 'EMPLOYEE'
      ehAdmin: sessao?.tipo === 'ADMIN',
      business_id: sessao?.business_id ?? null,
      login, logout,
    }}>
      {children}
    </AuthContext.Provider>
  );
};
